import { memo } from 'react';
import { handleDomBubbleEvent } from '@/utils/dom';
import { Input } from '@/components/_ui/input';
import useUpdateSpaceModal from './use-update-space-modal';
import { cn } from '@/utils/cn';
import {
  ModalCloseButton,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalFooter,
  ModalConfirmButton,
} from '@/components/_ui/modal';
import { Spinner } from '@/components/_ui/spinner';

export type TUpdateSpaceModalType = 'UpdateSpaceModal';
export interface IUpdateSpaceModalProps {
  spaceId: string;
  name?: string | null;
  description?: string | null;
  icon?: string | null;
}
const UpdateSpaceModal = memo((props: IUpdateSpaceModalProps) => {
  const {
    // Form
    form,

    // Modal
    isOpenUpdateSpaceModal,
    isDisabledButton,
    isLoadingButton,

    // File upload
    fileInputRef,
    iconPreview,
    fileError,
    handleFileChange,
    handleIconClick,

    // Handlers
    handleSubmitForm,
    handleClose,
  } = useUpdateSpaceModal(props);

  return (
    <Modal
      isOpen={isOpenUpdateSpaceModal}
      lockBodyScroll
      onClose={handleClose}
      className="p-[32px] md:w-[500px] w-[345px]"
    >
      <ModalHeader>
        <ModalTitle>Update Space</ModalTitle>
      </ModalHeader>
      <ModalContent>
        <form
          onSubmit={(e) => {
            handleDomBubbleEvent(e);
            form.handleSubmit(handleSubmitForm)(e);
          }}
          id="update-space-form"
          className="grid gap-[16px]"
        >
          <label htmlFor="" className="text-[12px] block font-[400] text-[#9D9D9C]">
            Update space information.
          </label>

          <div className="grid gap-[4px]">
            <label htmlFor="name-space" className="text-[#4B4B4B] text-[14px] font-normal">
              Icon & Name*
            </label>
            <div className="flex gap-[10px]">
              <div className="relative">
                <input ref={fileInputRef} type="file" accept="image/*" onChange={handleFileChange} className="hidden" />
                <div
                  onClick={handleIconClick}
                  className={cn(
                    'border w-[38px] h-[38px] flex-shrink-0 border-[#D9D9D9] rounded-[8px] flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity relative group',
                    {
                      'bg-[#A9E7FF]': !iconPreview,
                    }
                  )}
                >
                  {iconPreview ? (
                    <>
                      <img src={iconPreview} alt="Icon preview" className="w-full h-full object-cover rounded-[8px]" />
                      {/* <button
                        type="button"
                        onClick={handleRemoveIcon}
                        className="absolute top-[-4px] right-[-4px] w-4 h-4 bg-[#C72020] text-white flex items-center justify-center rounded-full transition-opacity z-10"
                        aria-label="Remove icon"
                      >
                        <XIcon className="w-3 h-3 text-white" aria-hidden="true" />
                      </button> */}
                    </>
                  ) : (
                    <span className="text-[18px] font-bold text-[#0C8DBF]">
                      {form.watch('name')?.charAt(0)?.toUpperCase() || 'R'}
                    </span>
                  )}
                </div>
                {fileError && <p className="text-[12px] text-red-500 mt-1">{fileError}</p>}
              </div>
              <div className="flex-1">
                <Input id="name-space" placeholder="Name" {...form.register('name')} />
                {form.formState.errors.name && (
                  <p className="text-red-500 text-[12px] font-normal mt-1">{form.formState.errors.name.message}</p>
                )}
              </div>
            </div>
          </div>

          <div className="grid gap-[4px]">
            <label htmlFor="description-space" className="text-[#4B4B4B] text-[14px] font-normal">
              Description <span className="text-[#9D9D9C] text-[12px] font-normal">(Optional)</span>
            </label>
            <Input id="description-space" placeholder="Description" {...form.register('description')} />
            {form.formState.errors.description && (
              <p className="text-red-500 text-[12px] font-normal">{form.formState.errors.description.message}</p>
            )}
          </div>
        </form>
      </ModalContent>
      <ModalFooter>
        <ModalCloseButton
          onClick={(e) => {
            handleDomBubbleEvent(e);
            handleClose();
          }}
        >
          Cancel
        </ModalCloseButton>
        <ModalConfirmButton form="update-space-form" type="submit" disabled={isDisabledButton}>
          {isLoadingButton ? <Spinner isLoading={true} className="w-[18px] h-[18px]" /> : null} Update
        </ModalConfirmButton>
      </ModalFooter>
    </Modal>
  );
});
UpdateSpaceModal.displayName = 'UpdateSpaceModal';

export default UpdateSpaceModal;
